import React from 'react';

export type IconButtonProps = {
  icon: React.FC<React.ComponentProps<'svg'>>;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  disabledColor?: string;
  color?: string;
  disabledStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  disabledClassName?: string;
  className?: string;
} & React.ComponentProps<'svg'>;

export const IconButton: React.FC<IconButtonProps> = ({
  disabled = false,
  icon,
  disabledClassName = 'text-secondary',
  className,
  disabledStyle = {},
  style = {},
  disabledColor,
  color,
  onClick,
  ...props
}) => {
  return React.createElement(icon, {
    ...props,
    role: 'button',
    // @ts-expect-error
    disabled,
    onClick: disabled ? undefined : onClick,
    color: disabled ? disabledColor : color,
    className: disabled ? disabledClassName : className,
    style: disabled
      ? { cursor: 'default', outline: 'none', ...disabledStyle }
      : { cursor: 'pointer', outline: 'none', ...style },
  });
};
